import type { Expand } from "../types/Brand"
import { Partial } from "../functions/Partial"

// T = static data type (props)
// M = method signatures without self (what the user sees after binding)

type UnboundMethods<T, M> = {
  [K in keyof M]: M[K] extends (...args: infer Args) => infer R
    ? (self: EntityInstance<T, M>, ...args: Args) => R
    : never
}

type EntityInstance<T, M> = Readonly<Expand<M & T>>

export const EntityFactory =
  <T, M>() =>
  (methods: UnboundMethods<T, M>): ((props: T) => EntityInstance<T, M>) => {
    return (props: T): EntityInstance<T, M> => {
      const instance = { ...props } as EntityInstance<T, M>
      for (const key in methods) {
        ;(instance as any)[key] = Partial(methods[key] as any, instance)
      }
      return instance as EntityInstance<T, M>
    }
  }
